import React from 'react'
import './macro-circle.css'

interface MacroCircleProps {
  goal: number
  value: number
  color: string
  unit: string
  title: string
}

function MacroCircle({ goal, value, color, unit, title }: MacroCircleProps) {
  const percentage = Math.min((value / goal) * 100, 100)

  const size = 120
  const strokeWidth = 8
  const radius = (size - strokeWidth) / 2
  const circumference = 2 * Math.PI * radius
  const strokeDashoffset = circumference - (percentage / 100) * circumference

  const formatNumber = (value: number): string => {
    const formatted = value.toFixed(1)
    return formatted.endsWith('.0') ? formatted.slice(0, -2) : formatted
  }

  return (
    <div className='macro-circle'>
      <div className='macro-circle__chart'>
        <svg viewBox={`0 0 ${size} ${size}`} className='macro-circle__svg'>
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill='none'
            stroke='#F1F2FE'
            strokeWidth={strokeWidth}
          />

          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            fill='none'
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            strokeLinecap='round'
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
            className='macro-circle__progress'
          />
        </svg>

        <div className='macro-circle__values'>
          <div className='macro-circle__value'>
            {formatNumber(value)}
            {unit}
          </div>
          <div className='macro-circle__divider' />
          <div className='macro-circle__goal'>
            {goal.toLocaleString()}
            {unit}
          </div>
        </div>
      </div>

      <div className='macro-circle__title'>{title}</div>
    </div>
  )
}

export default MacroCircle
